import { GridCurve } from './GridCurve';
import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';
import { GridAvailability } from '@/dto/scenario/grid/GridAvailability';
import { GridComplexPricing } from '@/dto/scenario/eco/GridComplexPricing';

export class ScenarioGrid {

  public hasGrid24: boolean | null = null;

  public hasDifferentAvailabilityAfter: boolean | null = null;

  public availabilityTypeRefBefore: GridAvailability | null = null;
  public availabilityTypeRefAfter: GridAvailability | null = null;

  public averageGridConnectionHoursPerDayBefore: number | null = null;
  public averageGridConnectionHoursPerDayAfter: number | null = null;

  public gridComplexAvailabilityBefore: GridComplexPricing | null = null;
  public gridComplexAvailabilityAfter: GridComplexPricing | null = null;

  public averageGridConnectionPercentagePerDayBefore: number | null = null;
  public averageGridConnectionPercentagePerDayAfter: number | null = null;

  public calculatedCurveBefore: GridCurve | null = null;
  public calculatedCurveAfter: GridCurve | null = null;

  public hasGridLimitation: boolean | null = null;

  public limitPower: number | null = null;

  public limitPercentage: number | null = null;

  public constructor(obj: ObjectOnly = {}) {
    assignToThis(this, obj);

    this.calculatedCurveBefore = this.calculatedCurveBefore ? new GridCurve(this.calculatedCurveBefore) : null;
    this.calculatedCurveAfter = this.calculatedCurveAfter ? new GridCurve(this.calculatedCurveAfter) : null;
  }
}
